import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomeTwo from './Components/Aero/HomeTwo';
import AdminDashboard from './Components/AdminDashboard';
import EvePage from './Components/Eve/EvePage';
import TeamPage from './Components/TeamPage';
//import DeckPage from './Components/DeckAndInvest/DeckPage';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<HomeTwo />} />
          <Route path="/eve" element={<EvePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

// <Route path="/invest" element={<DeckPage />} /> **ADD AFTER ADMIN ROUTE IF NEEDED**